import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { FiEdit } from "react-icons/fi";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete, MdOutlinePrint, MdPrint } from "react-icons/md";
import {
  deleteQuotation,
  getAllQuotations,
  getQuotationHistoryByParentID,
  sendQuotationByEmail,
} from "./services/quotation.services";
import {
  clearQuotationFilterDetails,
  clearQuotationID,
  setQuotationID,
  setQuotationPaymentBifurcation,
} from "./quotationSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import PackageQuotationFilter from "./PackageQuotationFilter";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { BsBookmarkPlusFill } from "react-icons/bs";
import { FaBookMedical, FaEye } from "react-icons/fa";
import { generateFITBookingByQuotationID } from "../fitbooking/services/FITBooking.services";
import { RiBookMarkedLine } from "react-icons/ri";
import { TbMailShare } from "react-icons/tb";
import IconComponent from "../../components/common/IconComponent";
import AlertBox from "../../components/common/AlertBox";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { TbMailDollar } from "react-icons/tb";

const PackageQuotationGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const isEditBtnRef = useRef<any>(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const LeadID = location.state?.LeadID;
  const ContactID = location.state?.ContactID;
  const InquiryID = location.state?.InquiryID;
  const isAddAccess = checkAcessRights("/fitbooking", INSERT_ACCESS);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const QuotationList = useAppSelector(
    (state) => state.quotation.QuotationList
  );
  const loading = useAppSelector((state) => state.quotation.loading);
  const FITLoading = useAppSelector((state) => state.FITBooking.loading);
  const QuotationFilterDetails = useAppSelector(
    (state) => state.quotation.QuotationFilterDetails
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    const matchFilter = (id: any, filterId: any) =>
      (!id && !filterId) || (id && filterId);

    const hasMatchingFilterID =
      matchFilter(ContactID, QuotationFilterDetails?.filterContactID) &&
      matchFilter(InquiryID, QuotationFilterDetails?.filterInquiryID) &&
      matchFilter(LeadID, QuotationFilterDetails?.filterLeadID);

    if (hasMatchingFilterID) {
      dispatch(
        getAllQuotations({
          ...QuotationFilterDetails,
          limit: +pageLimit,
          skip: +currentPage * +pageLimit,
        })
      );
    }
  }, [QuotationFilterDetails, currentPage, pageLimit]);

  useEffect(() => {
    return () => {
      if (!isEditBtnRef.current) {
        dispatch(setCurrentPage(0));
        dispatch(setPageLimit(50));
        dispatch(clearQuotationFilterDetails());
      }
    };
  }, []);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const handleAddTourBooking = async (data: any) => {
    if (data?.ID) {
      dispatch(openDialog("bookingConfirmationDialog"));
      dispatch(setQuotationID(data?.ID));
    }
  };

  const MyEditCommandCell = (props: any) => {
    const handleEdit = (item: any) => {
      navigate("/quotation/package/edit", {
        state: {
          QuotationID: item?.ID,
          SectorID: item?.SectorID,
        },
      });
    };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteQuotation"));
      dispatch(setQuotationID(ID));
    };

    const handleSendEmail = async (ID: number, IsWOBifurcation: boolean) => {
      if (ID) {
        dispatch(openDialog("emailConfirmationDialog"));
        dispatch(setQuotationID(ID));
        dispatch(setQuotationPaymentBifurcation(IsWOBifurcation));
      }
    };

    const handlePrint = async (Quot_GUID: string) => {
      if (Quot_GUID) {
        window.open(`/quotation/package/view/${Quot_GUID}`);
      }
    };

    const handlePrintWB = async (Quot_GUID: string) => {
      if (Quot_GUID) {
        window.open(`/quotation/package/view/${Quot_GUID}?wb`);
      }
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => {
              isEditBtnRef.current = true;
              handleEdit(props.dataItem);
            }}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {isAddAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Generate FIT Booking"
            onClick={() => handleAddTourBooking(props.dataItem)}
            icon={FaBookMedical}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email"
          themeColor="success"
          onClick={() => handleSendEmail(props.dataItem.ID, false)}
          icon={TbMailDollar}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email Without Bifurcation"
          themeColor="success"
          onClick={() => handleSendEmail(props.dataItem.ID, true)}
          icon={TbMailShare}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Print"
          themeColor="dark"
          onClick={() => handlePrint(props.dataItem.Quot_GUID)}
          icon={MdPrint}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Print Without Bifurcation"
          themeColor="dark"
          onClick={() => handlePrintWB(props.dataItem.Quot_GUID)}
          icon={MdOutlinePrint}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 7 || props.index === 8 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props.tdProps} />
  );

  const ListingButtonCell = (props: any) => {
    const handleBookings = (ID: number) => {
      navigate("/tourbooking", { state: { QuotationID: ID } });
    };
    const handleFITBookings = (ID: number) => {
      navigate("/fitbooking", { state: { QuotationID: ID } });
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {false && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Tour Bookings"
            themeColor="tertiary"
            onClick={() => handleBookings(props.dataItem.ID)}
            icon={BsBookmarkPlusFill}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="FIT Bookings"
          themeColor="dark"
          onClick={() => handleFITBookings(props.dataItem.ID)}
          icon={RiBookMarkedLine}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "20px" }}
        />
      </td>
    );
  };

  const handleChildView = async (props: any) => {
    const res = await dispatch(getQuotationHistoryByParentID(props?.ParentID));
    if (res.meta?.requestStatus === "fulfilled") {
      dispatch(openDialog("childQuotationHistories"));
    }
  };

  return (
    <>
      <ChildSalesOrdersDialog />
      <DeleteQuotationDialog />
      <BookingConfirmationDialog />
      <EmailConfirmationDialog />
      {(loading || FITLoading) && <LoadingPanel gridRef={gridRef} />}
      <div
        style={{
          position: "relative",
          marginBottom: "10px",
          padding: "10px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          boxShadow: "0 0 10px gainsboro",
        }}
      >
        <PackageQuotationFilter />
      </div>
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 265px)" }}
        className="responsive-table"
        filterable={false}
        data={QuotationList}
        total={QuotationList[0]?.ItemCount || QuotationList?.length}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 50, 100, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="QuotationNo"
          title="Quotation No."
          width={130}
          cells={{
            data: (props: any) => (
              <td>
                {isEditAccess ? (
                  <div className="d-flex gap-2 align-items-center">
                    <div
                      className="hoverableName"
                      onClick={() =>
                        navigate("/quotation/package/edit", {
                          state: {
                            QuotationID: props.dataItem?.ID,
                            SectorID: props.dataItem?.SectorID,
                          },
                        })
                      }
                    >
                      {props.dataItem?.QuotationNo}
                    </div>
                    {props.dataItem?.ParentID &&
                    props.dataItem?.ParentID > 0 ? (
                      <div onClick={() => handleChildView(props.dataItem)}>
                        <Tooltip
                          anchorElement="target"
                          position="top"
                          parentTitle={true}
                        >
                          <IconComponent
                            icon={FaEye}
                            title="View History"
                            style={{
                              color: "green",
                              fontSize: 18,
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div className="normalName">
                    {props.dataItem?.QuotationNo}
                    {props.dataItem?.ParentID &&
                    props.dataItem?.ParentID > 0 ? (
                      <div onClick={() => handleChildView(props.dataItem)}>
                        <IconComponent
                          icon={FaEye}
                          style={{
                            color: "green",
                            fontSize: 18,
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </td>
            ),
          }}
        />
        <Column
          field="QuotationDate"
          title="Date"
          width={120}
          cells={{
            data: (props: any) => <td>{props.dataItem?.QuotationDate}</td>,
          }}
        />
        <Column
          field="StartDate"
          title="Tour Date"
          width={120}
          cells={{
            data: (props: any) => (
              <td>
                <p className="m-0">{props.dataItem?.StartDate}</p>
                <p className="m-0">{props.dataItem?.EndDate}</p>
              </td>
            ),
          }}
        />
        <Column
          field="FirstName"
          title="Name"
          width={300}
          cells={{
            data: (props: any) => (
              <td className="fw-bold">
                {props.dataItem?.FirstName} {props.dataItem?.LastName}
              </td>
            ),
          }}
        />
        <Column
          field="MobileNo"
          title="Mobile No."
          width={200}
          cells={{ data: (props: any) => <td>{props.dataItem?.MobileNo}</td> }}
        />
        <Column
          field="EmailID"
          title="Email ID"
          width={300}
          cells={{ data: (props: any) => <td>{props.dataItem?.EmailID}</td> }}
        />
        <Column
          field="CreatedName"
          title="Created By"
          width={210}
          cells={{
            data: (props: any) => <td>{props.dataItem?.CreatedName}</td>,
          }}
        />
        <Column
          field="ID"
          title="Details"
          cells={{ data: ListingButtonCell }}
          width={"110px"}
          filterable={false}
          locked={true}
        />
        {(isEditAccess || isDeleteAccess || isAddAccess) && (
          <Column
            field="ID"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"270px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteQuotationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const QuotationID = useAppSelector((state) => state.quotation.QuotationID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const QuotationFilterDetails = useAppSelector(
    (state) => state.quotation.QuotationFilterDetails
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteQuotation(ID));

      if (response.meta.requestStatus === "fulfilled") {
        dispatch(
          getAllQuotations({
            ...QuotationFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          })
        );
        dispatch(closeDialog());
        dispatch(clearQuotationID());
      } else {
        dispatch(
          getAllQuotations({
            ...QuotationFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          })
        );
        dispatch(closeDialog());
        dispatch(clearQuotationID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteQuotation" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Quotation"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Quotation?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(QuotationID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const BookingConfirmationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const QuotationID = useAppSelector((state) => state.quotation.QuotationID);
  const loading = useAppSelector((state) => state.FITBooking.loading);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const gridRef = useRef<any>(null);

  const handleConfirm = async (ID: number | null) => {
    if (ID) {
      const res = await dispatch(
        generateFITBookingByQuotationID({ QuotationID: ID })
      );
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(setCurrentPage(0));
        dispatch(setPageLimit(50));
        dispatch(closeDialog());
        navigate("/fitbooking");
      }
    }
  };

  return (
    <>
      {dialogName === "bookingConfirmationDialog" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Typography.h5>{"Booking Confirmation"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to generate this Booking?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="primary" />
                <Button
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={() => handleConfirm(QuotationID)}
                  type="button"
                >
                  Confirm
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const EmailConfirmationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const QuotationID = useAppSelector((state) => state.quotation.QuotationID);
  const IsWOBifurcation = useAppSelector(
    (state) => state.quotation.IsWOBifurcation
  );
  const loading = useAppSelector((state) => state.quotation.loading);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const gridRef = useRef<any>(null);

  const handleConfirm = async (ID: number | null) => {
    if (ID) {
      const res = await dispatch(
        sendQuotationByEmail({ ID: +ID, Is_Bifurcation: IsWOBifurcation })
      );
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(closeDialog());
      }
    }
  };

  return (
    <>
      {dialogName === "emailConfirmationDialog" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Typography.h5>{"Email Confirmation"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to send Email?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="primary" />
                <Button
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={() => handleConfirm(QuotationID)}
                  type="button"
                >
                  Confirm
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const ChildSalesOrdersDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const QuotationHistoryList = useAppSelector(
    (state) => state.quotation.QuotationHistoryList
  );
  const loading = useAppSelector((state) => state.quotation.loading);
  const isAddAccess = checkAcessRights("/fitbooking", INSERT_ACCESS);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  useEffect(() => {
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const MyEditCommandCell = (data: any) => {
    const handleEdit = (item: any) => {
      navigate("/quotation/package/edit", {
        state: {
          QuotationID: item?.ID,
          SectorID: item?.SectorID,
        },
      });
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteQuotation"));
      dispatch(setQuotationID(ID));
    };

    const handleAddTourBooking = async (data: any) => {
      if (data?.ID) {
        dispatch(openDialog("bookingConfirmationDialog"));
        dispatch(setQuotationID(data?.ID));
      }
    };

    const handleSendEmail = async (ID: number, IsWOBifurcation: boolean) => {
      if (ID) {
        dispatch(openDialog("emailConfirmationDialog"));
        dispatch(setQuotationID(ID));
        dispatch(setQuotationPaymentBifurcation(IsWOBifurcation));
      }
    };

    const handlePrint = async (Quot_GUID: string) => {
      if (Quot_GUID) {
        window.open(`/quotation/package/view/${Quot_GUID}`);
      }
    };

    const handlePrintWB = async (Quot_GUID: string) => {
      if (Quot_GUID) {
        window.open(`/quotation/package/view/${Quot_GUID}?wb`);
      }
    };

    return (
      <td className="action-td">
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => {
              // isEditBtnRef.current = true;
              handleEdit(data?.item);
            }}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {isAddAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Generate FIT Booking"
            onClick={() => handleAddTourBooking(data?.item)}
            icon={FaBookMedical}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(data?.item?.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email"
          themeColor="success"
          onClick={() => handleSendEmail(data?.item?.ID, false)}
          icon={TbMailDollar}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email Without Bifurcation"
          themeColor="success"
          onClick={() => handleSendEmail(data?.item?.ID, true)}
          icon={TbMailShare}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Print"
          themeColor="dark"
          onClick={() => handlePrint(data?.item.Quot_GUID)}
          icon={MdPrint}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Print Without Bifurcation"
          themeColor="dark"
          onClick={() => handlePrintWB(data?.item.Quot_GUID)}
          icon={MdOutlinePrint}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
      </td>
    );
  };

  const ListingButtonCell = (data: any) => {
    const handleBookings = (ID: number) => {
      navigate("/tourbooking", { state: { QuotationID: ID } });
    };
    const handleFITBookings = (ID: number) => {
      navigate("/fitbooking", { state: { QuotationID: ID } });
    };

    return (
      <td className={`action-td`}>
        {false && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Tour Bookings"
            themeColor="tertiary"
            onClick={() => handleBookings(data?.item?.ID)}
            icon={BsBookmarkPlusFill}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="FIT Bookings"
          themeColor="dark"
          onClick={() => handleFITBookings(data?.item?.ID)}
          icon={RiBookMarkedLine}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "20px" }}
        />
      </td>
    );
  };

  return (
    <>
      {dialogName === "childQuotationHistories" && (
        <AppDialog>
          <>
            <Typography.h5>{"Quotation History"}</Typography.h5>
            <GridLayout style={{ position: "relative" }}>
              {loading && <LoadingPanel gridRef={gridRef} />}
              <GridLayoutItem
                style={{
                  maxHeight: "calc(100vh - 160px)",
                  overflow: "auto",
                  scrollbarWidth: "thin",
                  borderBottom: "1px solid lightgray",
                }}
              >
                {QuotationHistoryList && QuotationHistoryList?.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr style={{ whiteSpace: "nowrap" }}>
                          <th style={{ background: "black", color: "white" }}>
                            Quotation No
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Date
                          </th>
                          <th
                            style={{
                              background: "black",
                              color: "white",
                              minWidth: 150,
                            }}
                          >
                            Name
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Mobile No.
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Email ID
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Created By
                          </th>
                          <th
                            style={{
                              background: "black",
                              color: "white",
                              minWidth: 90,
                            }}
                          >
                            Details
                          </th>
                          <th
                            style={{
                              background: "black",
                              color: "white",
                              minWidth: 160,
                            }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {QuotationHistoryList?.map(
                          (item: any, index: number) => (
                            <tr key={index}>
                              <td>
                                {isEditAccess ? (
                                  <div className="d-flex gap-2 align-items-center">
                                    <div
                                      className="hoverableName"
                                      onClick={() =>
                                        navigate("/quotation/package/edit", {
                                          state: {
                                            QuotationID: item?.ID,
                                            SectorID: item?.SectorID,
                                          },
                                        })
                                      }
                                    >
                                      {item?.QuotationNo}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="normalName">
                                    {item?.QuotationNo}
                                  </div>
                                )}
                              </td>
                              <td>{item?.CreatedOn}</td>
                              <td>
                                <div className="fw-600">
                                  {item?.FirstName} {item?.LastName}
                                </div>
                              </td>
                              <td>{item?.MobileNo}</td>
                              <td>{item?.EmailID}</td>
                              <td>{item?.CreatedName}</td>
                              <td className="d-flex justify-content-center">
                                <ListingButtonCell item={item} />
                              </td>
                              <td>
                                <MyEditCommandCell item={item} />
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <AlertBox style={{ marginBottom: 10 }} />
                )}
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: 20,
                }}
              >
                <DialogCloseButton themeColor="error" />
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default PackageQuotationGridComponent;
